var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, computed } from "mobx";
import { LiveGameState } from "../LiveGameState";
import { parseTimeFull } from "sb-helpers";
import { Scoreboard } from "../Scoreboard";
import { GameStatus } from "../../helpers";
import { MasterEventInitialData } from "./MasterEventInitialData";
export class MasterEvent extends MasterEventInitialData {
    constructor(masterEventData) {
        super(masterEventData);
        this.score1 = masterEventData.score1;
        this.score2 = masterEventData.score2;
        this.scoreboard = masterEventData.scoreboard;
        this.isLive = masterEventData.isLive;
        this.markets = masterEventData.markets;
        this.liveGameState = masterEventData.liveGameState;
        this.liveStartCountdown = masterEventData.liveStartCountdown || 0;
        this.status = masterEventData.status;
    }
    update(masterEvent) {
        this.score1 = masterEvent.score1;
        this.score2 = masterEvent.score2;
        this.isLive = masterEvent.isLive;
        this.liveStartCountdown = masterEvent.liveStartCountdown;
        this.updateLiveGameState(masterEvent);
        this.scoreboard = masterEvent.scoreboard;
        this.status = masterEvent.status;
    }
    updateLiveStartCountdown(liveStartCountdown) {
        this.liveStartCountdown = liveStartCountdown;
    }
    updateLiveGameState(masterEvent) {
        this.liveGameState && masterEvent.liveGameState
            ? this.liveGameState.update(masterEvent.liveGameState)
            : (this.liveGameState = masterEvent.liveGameState);
    }
    removeMarkets(marketIds) {
        for (let i = 0; i < marketIds.length; i++) {
            let market2removeIndex = this.markets.map(m => m.id).indexOf(marketIds[i]);
            if (market2removeIndex !== -1) {
                this.markets.splice(market2removeIndex, 1);
            }
        }
    }
    upsertMarket(market) {
        let existingMarkets = this.markets.map(m => m.id);
        let existingMarketIndex = existingMarkets.indexOf(market.id);
        existingMarketIndex !== -1
            ? this.markets[existingMarketIndex].update(market)
            : this.markets.push(market);
    }
    get formattedCountdown() {
        return parseTimeFull(this.liveStartCountdown);
    }
}
__decorate([
    observable,
    __metadata("design:type", String)
], MasterEvent.prototype, "score1", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], MasterEvent.prototype, "score2", void 0);
__decorate([
    observable,
    __metadata("design:type", Scoreboard)
], MasterEvent.prototype, "scoreboard", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], MasterEvent.prototype, "markets", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], MasterEvent.prototype, "isLive", void 0);
__decorate([
    observable,
    __metadata("design:type", LiveGameState)
], MasterEvent.prototype, "liveGameState", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], MasterEvent.prototype, "status", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], MasterEvent.prototype, "liveStartCountdown", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [MasterEvent]),
    __metadata("design:returntype", void 0)
], MasterEvent.prototype, "update", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], MasterEvent.prototype, "updateLiveStartCountdown", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], MasterEvent.prototype, "formattedCountdown", null);
//# sourceMappingURL=MasterEvent.js.map